// src/data/masterData.js
import moment from 'moment';

const currentYear = moment().year();

const masterHolidays = {
  national: [
    { 
      id: 'nat_1', 
      name: 'Independence Day', 
      start_date: `${currentYear}-08-15`, 
      end_date: `${currentYear}-08-15`, 
      details: 'National Holiday' 
    },
    { 
      id: 'nat_2', 
      name: 'Gandhi Jayanti', 
      start_date: `${currentYear}-10-02`, 
      end_date: `${currentYear}-10-02`, 
      details: 'National Holiday' 
    },
    { 
      id: 'nat_3', 
      name: 'Republic Day', 
      start_date: `${currentYear + 1}-01-26`, 
      end_date: `${currentYear + 1}-01-26`, 
      details: 'National Holiday' 
    }
  ],

  festivals: [
    { id: 'fest_1', name: 'Ram Navmi', start_date: `${currentYear}-04-06`, end_date: `${currentYear}-04-06`, details: 'Festival' },
    { id: 'fest_2', name: 'Mahavir Jayanti', start_date: `${currentYear}-04-10`, end_date: `${currentYear}-04-10`, details: 'Festival' },
    { id: 'fest_3', name: 'Good Friday', start_date: `${currentYear}-04-18`, end_date: `${currentYear}-04-18`, details: 'Festival' },
    { id: 'fest_4', name: 'Buddha Purnima', start_date: `${currentYear}-05-12`, end_date: `${currentYear}-05-12`, details: 'Festival' },
    { id: 'fest_5', name: 'Id-ul-Zuha (Bakrid)', start_date: `${currentYear}-06-07`, end_date: `${currentYear}-06-07`, details: 'Festival' },
    { id: 'fest_6', name: 'Rath Yatra', start_date: `${currentYear}-06-27`, end_date: `${currentYear}-06-27`, details: 'Festival' },
    { id: 'fest_7', name: 'Muharram', start_date: `${currentYear}-07-06`, end_date: `${currentYear}-07-06`, details: 'Festival' },
    { id: 'fest_8', name: 'Raksha Bandhan', start_date: `${currentYear}-08-09`, end_date: `${currentYear}-08-09`, details: 'Festival' },
    { id: 'fest_9', name: 'Janmashtami', start_date: `${currentYear}-08-16`, end_date: `${currentYear}-08-16`, details: 'Festival' },
    { id: 'fest_10', name: 'Milad-un-Nabi', start_date: `${currentYear}-09-05`, end_date: `${currentYear}-09-05`, details: 'Festival' },
    { id: 'fest_11', name: 'Onam', start_date: `${currentYear}-09-05`, end_date: `${currentYear}-09-05`, details: 'Festival' },
    { id: 'fest_12', name: 'Govardhan Puja', start_date: `${currentYear}-10-22`, end_date: `${currentYear}-10-22`, details: 'Festival' },
    { id: 'fest_13', name: 'Bhai Duj', start_date: `${currentYear}-10-23`, end_date: `${currentYear}-10-23`, details: 'Festival' },
    { id: 'fest_14', name: "Guru Nanak's Birthday", start_date: `${currentYear}-11-05`, end_date: `${currentYear}-11-05`, details: 'Festival' },
    { id: 'fest_15', name: 'Christmas Day', start_date: `${currentYear}-12-25`, end_date: `${currentYear}-12-25`, details: 'Festival' }
  ],

  vacations: [
    { 
      id: 'vac_1', 
      name: 'Summer Vacation', 
      start_date: `${currentYear}-05-01`, 
      end_date: `${currentYear}-06-15`, 
      details: 'Long Vacation' 
    },
    { 
      id: 'vac_2', 
      name: 'Winter Vacation', 
      start_date: `${currentYear}-12-20`, 
      end_date: `${currentYear + 1}-01-10`, 
      details: 'Winter Break' 
    },
    { 
      id: 'vac_3', 
      name: 'Term Break', 
      start_date: `${currentYear}-10-05`, 
      end_date: `${currentYear}-10-10`, 
      details: 'Mid-term Break' 
    }
  ]
};

const masterCompetitions = {
  academic: [
    { id: 'acad_1', name: 'English Debate Competition', start_date: `${currentYear}-04-01`, end_date: `${currentYear}-04-01`, details: 'Academic Competition' },
    { id: 'acad_2', name: 'Hindi Debate competition', start_date: `${currentYear}-04-05`, end_date: `${currentYear}-04-05`, details: 'Academic Competition' },
    { id: 'acad_3', name: 'Extempore Competition', start_date: `${currentYear}-05-10`, end_date: `${currentYear}-05-10`, details: 'Academic Competition' },
    { id: 'acad_4', name: 'English Handwriting Competition', start_date: `${currentYear}-06-01`, end_date: `${currentYear}-06-01`, details: 'Academic Competition' },
    { id: 'acad_5', name: 'Hindi Handwriting Competition', start_date: `${currentYear}-06-05`, end_date: `${currentYear}-06-05`, details: 'Academic Competition' },
    { id: 'acad_6', name: 'English Speech', start_date: `${currentYear}-07-10`, end_date: `${currentYear}-07-10`, details: 'Academic Competition' },
    { id: 'acad_7', name: 'Hindi Speech', start_date: `${currentYear}-07-15`, end_date: `${currentYear}-07-15`, details: 'Academic Competition' },
    { id: 'acad_8', name: 'Quiz', start_date: `${currentYear}-08-01`, end_date: `${currentYear}-08-01`, details: 'Academic Competition' },
    { id: 'acad_9', name: 'Science Exhibition', start_date: `${currentYear}-09-10`, end_date: `${currentYear}-09-10`, details: 'Academic Competition' },
    { id: 'acad_10', name: 'Poetry Competition', start_date: `${currentYear}-10-05`, end_date: `${currentYear}-10-05`, details: 'Academic Competition' },
    { id: 'acad_11', name: 'Essay writing Hindi', start_date: `${currentYear}-11-01`, end_date: `${currentYear}-11-01`, details: 'Academic Competition' },
    { id: 'acad_12', name: 'Essay Writing English', start_date: `${currentYear}-11-05`, end_date: `${currentYear}-11-05`, details: 'Academic Competition' },
    { id: 'acad_13', name: 'Maths Olympiad', start_date: `${currentYear}-12-10`, end_date: `${currentYear}-12-10`, details: 'Academic Competition' },
    { id: 'acad_14', name: 'Science Olympiad', start_date: `${currentYear}-12-15`, end_date: `${currentYear}-12-15`, details: 'Academic Competition' }
  ],

  extracurricular: [
    { id: 'extra_1', name: 'Drawing/Art & Craft Competition', start_date: `${currentYear}-04-15`, end_date: `${currentYear}-04-15`, details: 'Art Competition' },
    { id: 'extra_2', name: 'Fancy Dress Competition', start_date: `${currentYear}-05-20`, end_date: `${currentYear}-05-20`, details: 'Extracurricular' },
    { id: 'extra_3', name: 'Fashion Show', start_date: `${currentYear}-06-10`, end_date: `${currentYear}-06-10`, details: 'Extracurricular' },
    { id: 'extra_4', name: 'Music Competition', start_date: `${currentYear}-07-20`, end_date: `${currentYear}-07-20`, details: 'Extracurricular' },
    { id: 'extra_5', name: 'Rakhi Making Competition', start_date: `${currentYear}-08-05`, end_date: `${currentYear}-08-05`, details: 'Extracurricular' },
    { id: 'extra_6', name: 'Rangoli Making Competition', start_date: `${currentYear}-09-15`, end_date: `${currentYear}-09-15`, details: 'Extracurricular' },
    { id: 'extra_7', name: 'Cooking Competition', start_date: `${currentYear}-10-10`, end_date: `${currentYear}-10-10`, details: 'Extracurricular' },
    { id: 'extra_8', name: 'Card Making Competition', start_date: `${currentYear}-11-20`, end_date: `${currentYear}-11-20`, details: 'Extracurricular' }
  ]
};

const masterExams = [
  { id: 'exam_1', name: 'Mid-Term Exams', start_date: `${currentYear}-09-15`, end_date: `${currentYear}-09-25`, details: 'First term examinations' },
  { id: 'exam_2', name: 'Final Exams', start_date: `${currentYear + 1}-03-01`, end_date: `${currentYear + 1}-03-15`, details: 'Annual final examinations' },
  { id: 'exam_3', name: 'Unit Test 1', start_date: `${currentYear}-07-01`, end_date: `${currentYear}-07-03`, details: 'First unit test' },
  { id: 'exam_4', name: 'Unit Test 2', start_date: `${currentYear}-11-01`, end_date: `${currentYear}-11-03`, details: 'Second unit test' }
];

const masterCelebrations = {
  celebrations: [
    { id: 'cele_1', name: 'Teachers Day', start_date: `${currentYear}-09-05`, end_date: `${currentYear}-09-05`, details: 'Teachers Day Celebration' },
    { id: 'cele_2', name: 'Childrens Day', start_date: `${currentYear}-11-14`, end_date: `${currentYear}-11-14`, details: 'Childrens Day Celebration' },
    { id: 'cele_3', name: 'Annual Function', start_date: `${currentYear}-12-20`, end_date: `${currentYear}-12-20`, details: 'School Annual Day' }
  ],};
  const masterawarenessDays ={ 
    awareness: [
    { id: 'aware_1', name: 'World Health Day', start_date: `${currentYear}-04-07`, end_date: `${currentYear}-04-07`, details: 'Health Awareness Day' },
    { id: 'aware_2', name: 'Earth Day', start_date: `${currentYear}-04-22`, end_date: `${currentYear}-04-22`, details: 'Environmental Awareness' },
    { id: 'aware_3', name: 'International Yoga Day', start_date: `${currentYear}-06-21`, end_date: `${currentYear}-06-21`, details: 'Health Awareness' }
  ],
};

export default {
  holidays: masterHolidays,
  competitions: masterCompetitions,
  exams: masterExams,
  celebrations: masterCelebrations,
  awareness: masterawarenessDays,
};